// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ab9406ef","977":"7fc6f0c8"}[chunkId] + ".chunk.js";
};